import { Router } from 'pjax';
import form from './form.js';

Router.get('entry-form/entrant/:any', form);
Router.get('entry-form/manager/([a-zA-Z]+)', form);
Router.get('entry-form/manager/([a-zA-Z]+)/edit', form);
